import styled from "styled-components";
import { types } from "../../../libs/themes";

export const Overlay = styled.div<{ $isClosing?: boolean }>`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.6);
    z-index: 99999;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 16px;
    animation: ${({ $isClosing }) => $isClosing ? 'fadeOut' : 'fadeIn'} 0.25s ease-out forwards;

    @keyframes fadeIn {
        from { opacity: 0; }
        to { opacity: 1; }
    }

    @keyframes fadeOut {
        from { opacity: 1; }
        to { opacity: 0; }
    }
`;

export const ModalContainer = styled.div<{ $isClosing?: boolean }>`
    background-color: ${({ theme }) => theme.mobileModalBg};
    color: ${({ theme }) => theme.mobileModalColor};
    border-radius: 12px;
    width: 100%;
    max-width: 400px;
    max-height: 85vh;
    overflow-y: auto;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
    position: relative;
    animation: ${({ $isClosing }) => $isClosing ? 'slideDown' : 'slideUp'} ${({ $isClosing }) => $isClosing ? '0.25s' : '0.3s'} ease-out forwards;

    @keyframes slideUp {
        from {
            opacity: 0;
            transform: translateY(40px) scale(0.96);
        }
        to {
            opacity: 1;
            transform: translateY(0) scale(1);
        }
    }

    @keyframes slideDown {
        from {
            opacity: 1;
            transform: translateY(0) scale(1);
        }
        to {
            opacity: 0;
            transform: translateY(40px) scale(0.96);
        }
    }
`;

export const CloseButton = styled.button`
    position: absolute;
    top: 8px;
    right: 8px;
    background: rgba(0, 0, 0, 0.5);
    border: none;
    color: white;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    z-index: 10;
    font-size: 18px;
    line-height: 1;

    &:hover {
        background: rgba(0, 0, 0, 0.7);
    }
`;

export const ThumbnailWrapper = styled.div`
    line-height: 0;
    aspect-ratio: 16 / 9;
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;
    overflow: hidden;

    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
`;

export const ContentWrapper = styled.div`
    padding: 16px 20px 20px;
`;

export const TrailerSection = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
`;

export const TrailerButton = styled.button`
    display: flex;
    align-items: center;
    gap: 8px;
    background-color: ${({ theme }) => theme.watchButtonBg};
    color: ${({ theme }) => theme.watchButtonColor};
    border: 1px solid transparent;
    padding: 8px 14px;
    ${types.body.normal}
    font-weight: 700 !important;
    cursor: pointer;
    border-radius: 4px;
    flex: 1;
    justify-content: center;

    &:hover {
        background-color: ${({ theme }) => theme.watchButtonHover};
    }

    &:focus {
        outline: none;
    }
`;

export const Title = styled.div`
    ${types.headers.itemMedium};
    line-height: 1.3;
    margin: 0 0 8px 0;
    word-break: break-word;
    color: ${({ theme }) => theme.mobileModalColor};
`;

export const Description = styled.div`
    font-size: 13.01px;
    font-weight: 400;
    line-height: 1.4;
    margin: 0 0 12px 0;
    color: ${({ theme }) => theme.mobileModalSubText};
`;

export const GenrePills = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 5px;
    margin-bottom: 12px;
`;

export const Genre = styled.div`
    ${types.headers.normal}
    padding: 2px 8px;
    border: 1px solid ${({ theme }) => theme.mobileModalGenreBorder};
    border-radius: 20px;
    display: flex;
    align-items: center;
    color: ${({ theme }) => theme.mobileModalGenreColor};
    font-size: 12px;
`;

export const InfoRow = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 12px;
    margin-bottom: 12px;
`;

export const InfoItem = styled.div`
    display: flex;
    align-items: center;
    gap: 4px;

    svg {
        width: 16px;
        height: 16px;
        flex-shrink: 0;
    }

    span, div {
        font-size: 13.01px;
        font-weight: 600;
        margin: 0;
    }
`;

export const MetadataRow = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    align-items: center;
    margin-bottom: 12px;
    font-size: 13.01px;
    color: ${({ theme }) => theme.mobileModalSubText};

    .release-year,
    .duration {
        font-weight: 400;
    }

    .mpaa-rating {
        span {
            background: #eee;
            border-radius: 4px;
            padding: 2px 4px;
            font-size: 12px;
            color: #333;
        }
    }

    .viewer-rating {
        font-weight: 700;
        .viewer-rating--filled {
            color: var(--viewer-rating-filled-color, #f5a623);
        }
        .viewer-rating--empty {
            color: var(--viewer-rating-empty-color, #ccc);
        }
    }
`;

export const RatingWrapper = styled.div`
    margin: 8px 0;
    display: flex;
    flex-flow: row;
    justify-content: flex-start;
    align-items: center;

    svg {
        fill: currentColor;
        color: currentColor;
    }
`;

export const CrewSection = styled.div`
    margin-top: 8px;
    color: ${({ theme }) => theme.mobileModalSubText};
`;

export const CrewItem = styled.div`
    font-size: 13.01px;
    font-weight: 400;
    line-height: 1.4;
    margin: 0 0 6px 0;

    &:last-of-type {
        margin-bottom: 0;
    }

    span {
        font-weight: 700;
        display: block;
    }
`;
